import { AuthTokens, User } from '../domain/types';
import { AuthApi } from '../infrastructure/authApi';
import { AuthStorage } from '../infrastructure/authStorage';

export class RefreshTokenUseCase {
  private authApi: AuthApi;
  private authStorage: AuthStorage;

  constructor() {
    this.authApi = new AuthApi();
    this.authStorage = new AuthStorage();
  }

  async execute(): Promise<AuthTokens | null> {
    const refreshToken = this.authStorage.getRefreshToken();
    if (!refreshToken) return null;

    const response = await this.authApi.refreshToken(refreshToken);

    if (response.success && response.tokens && response.tokens.refresh) {
      const tokens: AuthTokens = {
        access: response.tokens.access,
        refresh: response.tokens.refresh,
      };
      if (response.user) {
        this.authStorage.setAuthData(tokens, response.user);
      } else {
        this.authStorage.setTokens(tokens);
      }
      return tokens;
    }

    return null;
  }
}

